
const iflowURLMap = {
    sit: 'https://dc-sit.annto.com/iflow-page',
    uat: 'https://dc-uat.annto.com/iflow-page',
    ver: 'https://dc-ver.annto.com/iflow-page',
    prod: 'https://dc.annto.com/iflow-page'
};

/* TODO: 用于金种子用户的iflow外链域名 */
export const seedIflowURLMap = {
    sit: 'https://an-sit.annto.com',
    uat: 'https://an-uat.annto.com',
    ver: 'https://an-ver.annto.com',
    prod: 'https://an.annto.com'
};

export function currentEnv () {
    const hostname = location.hostname;
    let env = 'uat';

    if (hostname.includes('localhost')) {
        env = 'uat';
    } else {
        if (hostname.includes('-sit.')) {
            env = 'sit';
        } else if (hostname.includes('-uat.')) {
            env = 'uat';
        } else if (hostname.includes('-ver.')) {
            env = 'ver';
        } else {
            env = 'prod';
        }
    }
    return env;
}

export function loginUser(store) {
    return store.getters.user;
}

export function iflowPageURL (user, fdId, fdTemplateKey) {
    const env = currentEnv();
    let url = `${iflowURLMap[env] || iflowURLMap.uat}?fdId=${fdId}&userCode=${user.userCode}&userName=${user.userName}`;
    if (fdTemplateKey) {
        url = `${url}&fdTemplateKey=${fdTemplateKey}`;
    }
    return url;
}